/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Download_InvoiceInputs */

const en_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Invoice`)
};

const es_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar Factura`)
};

const fr_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger la facture`)
};

const de_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnung herunterladen`)
};

const id_download_invoice = /** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh Faktur`)
};

/** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */
const ja_download_invoice = en_download_invoice;

/** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */
const zh_download_invoice = en_download_invoice;

/** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */
const ar_download_invoice = en_download_invoice;

/** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */
const it_download_invoice = en_download_invoice;

/** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */
const ru_download_invoice = en_download_invoice;

/** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */
const pt_download_invoice = en_download_invoice;

/** @type {(inputs: Download_InvoiceInputs) => LocalizedString} */
const ko_download_invoice = en_download_invoice;

/**
* | output |
* | --- |
* | "Download Invoice" |
*
* @param {Download_InvoiceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const download_invoice = /** @type {((inputs?: Download_InvoiceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Download_InvoiceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_download_invoice(inputs)
	if (locale === "es") return es_download_invoice(inputs)
	if (locale === "fr") return fr_download_invoice(inputs)
	if (locale === "de") return de_download_invoice(inputs)
	if (locale === "ja") return ja_download_invoice(inputs)
	if (locale === "zh") return zh_download_invoice(inputs)
	if (locale === "ar") return ar_download_invoice(inputs)
	if (locale === "id") return id_download_invoice(inputs)
	if (locale === "it") return it_download_invoice(inputs)
	if (locale === "ru") return ru_download_invoice(inputs)
	if (locale === "pt") return pt_download_invoice(inputs)
	return ko_download_invoice(inputs)
});